module.exports = [["%","o10001","T101","%"],["%","o10001","T101","N160"," "," ","%"]]


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/active-program/program1.json
// module id = ./src/app/allPanels/active-program/program1.json
// module chunks = main